import { object, string } from "yup";
import { isUSA } from "../../../../../common/utils";
import {
  addressUsZipRegEx,
  alphanumericError,
  alphaNumericRegex,
  usZipSyntaxError,
} from "../../../../SharedAddressInput/constants";
import { TaxFormType } from "./constants";

export type VendorPayeeDetailsFields = {
  payeeName: string;
  country?: string;
  state?: string;
  province?: string;
  streetLine1?: string;
  streetLine2?: string;
  city?: string;
  zip?: string;
  form1099Required?: string;
  // Updated to match codebase patterns - separate fields instead of compound
  taxCountryId?: string;
  taxId?: string;
  taxFormType?: TaxFormType;
  taxFormFile?: File;
};

export const initialValues: VendorPayeeDetailsFields = {
  payeeName: "",
  country: undefined,
  state: undefined,
  province: undefined,
  streetLine1: undefined,
  streetLine2: undefined,
  city: undefined,
  zip: undefined,
  form1099Required: undefined,
  taxCountryId: undefined,
  taxId: undefined,
  taxFormType: undefined,
  taxFormFile: undefined,
};

export const payeeDetailsValidationSchema = object().shape({
  payeeName: string().required("Vendor name is a required field."),
  streetLine1: string().optional().matches(/\S/, "Cannot be just spaces"),
  streetLine2: string().optional().matches(/\S/, "Cannot be just spaces"),
  city: string().optional().matches(/\S/, "Cannot be just spaces"),
  state: string().optional(),
  province: string().optional().max(60, "Province must be 60 characters or less"),
  country: string().optional(),
  zip: string()
    .optional()
    .when(["country"], ([country], schema) => {
      if (!country) {
        return schema;
      }
      let zipSchema = schema;
      if (country && typeof country === "string" && isUSA(country)) {
        zipSchema = zipSchema.matches(addressUsZipRegEx, usZipSyntaxError);
      } else {
        zipSchema = zipSchema.matches(alphaNumericRegex, alphanumericError);
      }
      return zipSchema;
    }),
  // Tax ID fields - validation handled by FormIntlTaxIdInput component
  taxCountryId: string().optional(),
  taxId: string().optional(),
});
